/**
 * Precio de venta de un renglón surtido.
 *
 * Se prefiere el precio SELLADO al surtir (`precioUnitario`); si viene en 0
 * —renglones anteriores al sellado— se cae al precio vigente del pedido, que
 * es como se leía antes.
 *
 * Misma regla que MacuroBack/utils/precioSurtido.js: si cambia una, cambia la
 * otra, o los reportes del back y las pantallas dejan de coincidir.
 */
export function precioDeLinea(f) {
  const sellado = Number(f?.precioUnitario || 0);
  if (sellado > 0) return sellado;
  const ap = Array.isArray(f?.articulosPedido) ? f.articulosPedido[0] : f?.articulosPedido;
  return Number(ap?.precio || 0);
}

export function descuentoDeLinea(f) {
  if (Number(f?.precioUnitario || 0) > 0) return Number(f?.descuentoUnitario || 0);
  const ap = Array.isArray(f?.articulosPedido) ? f.articulosPedido[0] : f?.articulosPedido;
  return Number(ap?.descuento || 0);
}

export function precioNetoDeLinea(f) {
  return precioDeLinea(f) * (1 - descuentoDeLinea(f) / 100);
}
